module.exports = __webpack_public_path__ + "static/media/photo38.65ffbe00.jpg";